import SalesMonthlyReportLayout from './SalesMonthlyReportLayout';

export default SalesMonthlyReportLayout;
